import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { isTypingTarget, useUiStore } from '@/stores/ui';

export function GlobalShortcuts() {
  const navigate = useNavigate();
  const openCreateDrawer = useUiStore((state) => state.openCreateDrawer);
  const openCommandPalette = useUiStore((state) => state.openCommandPalette);
  const activeDrawer = useUiStore((state) => state.activeDrawer);
  const requestTaskDrawerCommand = useUiStore((state) => state.requestTaskDrawerCommand);
  const setNotice = useUiStore((state) => state.setNotice);
  const startVoiceInput = useUiStore((state) => state.startVoiceInput);

  useEffect(() => {
    const handler = (event: KeyboardEvent) => {
      if ((event.metaKey || event.ctrlKey) && event.key.toLowerCase() === 'k') {
        event.preventDefault();
        openCommandPalette('');
        return;
      }

      // Works even while typing (mirrors Cmd/Ctrl+K), so dictation is reachable
      // from inside Alice's own input.
      if ((event.metaKey || event.ctrlKey) && event.shiftKey && event.key.toLowerCase() === 'v') {
        event.preventDefault();
        startVoiceInput();
        return;
      }

      if (isTypingTarget(event.target) || event.metaKey || event.ctrlKey || event.altKey) return;

      const key = event.key.toLowerCase();
      if (key === '/') {
        event.preventDefault();
        openCommandPalette('/');
        return;
      }
      if (key === 'c') {
        event.preventDefault();
        openCreateDrawer({ type: 'task' });
        return;
      }
      if (key === 'v') {
        event.preventDefault();
        startVoiceInput();
        return;
      }
      if (key === 't') {
        event.preventDefault();
        navigate('/tasks');
        return;
      }
      if (key === 's') {
        event.preventDefault();
        navigate('/settings');
        return;
      }
      if (key === 'e') {
        event.preventDefault();
        requestTaskDrawerCommand('focus-edit');
        return;
      }
      if (key === 'u') {
        event.preventDefault();
        if (activeDrawer?.type === 'task') requestTaskDrawerCommand('send-update');
        else setNotice('Open a task before sending an update', 'destructive');
        return;
      }
      if (key === 'l') {
        event.preventDefault();
        if (activeDrawer?.type === 'task') requestTaskDrawerCommand('quick-log');
        else setNotice('Open a task before logging time', 'destructive');
        return;
      }
      if (key === 'd') {
        event.preventDefault();
        if (activeDrawer?.type === 'task') requestTaskDrawerCommand('close-task');
        else setNotice('Open a task before closing it', 'destructive');
      }
    };

    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [
    activeDrawer?.type,
    navigate,
    openCommandPalette,
    openCreateDrawer,
    requestTaskDrawerCommand,
    setNotice,
    startVoiceInput,
  ]);

  return null;
}
